import axios from "axios";
import { MAIN_URL, getApiHeaders } from "../Configurations/Urls";
import toast from "react-hot-toast";

function authHeaders() {
  return getApiHeaders();
}

function handleAuthError(error) {
  if (error.response && error.response.status === 401) {
    toast.error("Session Expired!");
    window.location.href = "/login";
  }
}

export async function fetchNotifications({
  organizationId,
  category = "all",
  unreadOnly = false,
  limit = 50,
} = {}) {
  try {
    const response = await axios.get(`${MAIN_URL}/api/notifications`, {
      headers: authHeaders(),
      params: {
        organization_id: organizationId,
        category: category && category !== "all" ? category : undefined,
        unread_only: unreadOnly || undefined,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function fetchUnreadNotificationCount(organizationId) {
  try {
    const response = await axios.get(`${MAIN_URL}/api/notifications/unread-count`, {
      headers: authHeaders(),
      params: { organization_id: organizationId },
    });
    return response.data?.data?.unread_count ?? 0;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function markNotificationRead(notificationId, organizationId) {
  try {
    const response = await axios.post(
      `${MAIN_URL}/api/notifications/${notificationId}/read`,
      { organization_id: organizationId },
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function markAllNotificationsRead(organizationId, category = null) {
  try {
    const response = await axios.post(
      `${MAIN_URL}/api/notifications/read-all`,
      {
        organization_id: organizationId,
        ...(category && category !== "all" ? { category } : {}),
      },
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function deleteNotification(notificationId, organizationId) {
  try {
    const response = await axios.delete(
      `${MAIN_URL}/api/notifications/${notificationId}`,
      {
        headers: authHeaders(),
        data: { organization_id: organizationId },
        params: { organization_id: organizationId },
      }
    );
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function fetchNotificationPreferences(organizationId) {
  try {
    const response = await axios.get(`${MAIN_URL}/api/notification-preferences`, {
      headers: authHeaders(),
      params: { organization_id: organizationId },
    });
    return response.data?.data ?? [];
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function saveNotificationPreferences(organizationId, preferences) {
  try {
    const response = await axios.put(
      `${MAIN_URL}/api/notification-preferences`,
      { organization_id: organizationId, preferences },
      { headers: authHeaders() }
    );
    return response.data?.data ?? [];
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}
